




























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import EmploymentTable from '@/components/reports/vedomost/components/Table.vue'
import TextInput from '@/components/reports/vedomost/components/TextInput.vue'
import CheckedInput from '@/components/reports/vedomost/components/CheckedInput.vue'
import { Page1Interface } from '@/components/reports/vedomost/helpers/Vedomost.interface'

@Component({
  components: { EmploymentTable, TextInput, CheckedInput }
})
export default class Page1 extends Vue {
  formData = {}

  @Prop({ type: Object, default: () => ({}) }) pageData!: Page1Interface

  @Watch('pageData') onChangePageData(val: Page1Interface): void {
    this.formData = val
  }

  setInputValue(keyName: string, value: string): void {
    this.formData[keyName] = value
  }
}
